import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
  apiCall, formattedPrice,
  getBranches, getCustomers,
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import { setReceivableChartData, setReceivableCustomersChartData, setDebtsChartData, setSupplierDebtsChartData } from "../../actions";
import ReceivableDataChart from "../../components/Charts/ReceivableDataChart";
import DebtsDataChart from "../../components/Charts/DebtsDataChart";
import ReceivableByCustomerPieChart from "../../components/Charts/ReceivableByCustomerPieChart";
import DebtsBySupplierPieChart from "../../components/Charts/DebtsBySupplierPieChart";
import Select from "react-select";
import ApproachingReceivablesTable from "../../components/Tables/ApproachingReceivablesTable";
import ApproachingDebtsTable from "../../components/Tables/ApproachingDebtsTable";
import { Modal, ModalHeader, ModalBody, Table } from "reactstrap";

class ReceivableReports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      receivablesTotals: [],
      receivablesChartData: [],
      debtsDataChart: [],
      receivablesCustomersChartData: [],
      supplierDebtsChartData: [],
      total: [],
      branches: [],
      customers: [],
      status: [],
      employes: [],
      type: [],
      selectedSupplier: null,
      selectedCustomer: null,
      activeTab: 'receivables', // 'receivables' veya 'debts'
      formData: {
        startDateTime: '',
        endDateTime: '',
        by_branch: '',
        by_customer: '',
        by_supplier: '',
      },
      loading: false,
      isLoad: true,
      // Modal için
      overpaidModalOpen: false,
      overpaidSuppliers: [],
      loadingOverpaid: false,

    }
  }
  async componentDidMount() {
    this.getReports();
    this.setState({
      customers: await getCustomers(),
    });
    /*const now = new Date();
    const localDateTime = new Date(now.getTime() - (now.getTimezoneOffset() * 60000))
        .toISOString()
        .slice(0, 16);
    this.setState( prevState => ({
        formData : {
          ...prevState.formData,
          startDateTime:localDateTime
        }
    }));*/
  }
  getReports = async () => {

    try {
      const response = await apiCall('business/reports/receivable', 'post', null);
      const branches = await getBranches();

      // DEBUG: İlk yükleme verilerini konsola yazdır
      console.log('📊 CARİ RAPOR - İLK YÜKLEME VERİLERİ:', {
        'Toplam Alacak': response.total?.totalReceivables,
        'Toplam Tahsilat': response.total?.totalCollectedReceivables,
        'Kalan Alacak': response.total?.totalRemainingReceivables,
        'Toplam Borç': response.total?.totalDebts,
        'Toplam Ödeme': response.total?.totalCollectedDebts,
        'Kalan Borç': response.total?.totalRemainingDebts,
      });

      this.setState({
        receivablesTotals: response.receivableTotals,
        receivablesChartData: response.getReceivableByMonth,
        debtsDataChart: response.getDebtsByMonth,
        receivablesCustomersChartData: response.getReceivableByCustomer,
        supplierDebtsChartData: response.getSupplierDebtsAndCollections,
        total: response.total,
        branches
      }, () => {
        this.props.setReceivableChartData(response.getReceivableByMonth);
        this.props.setDebtsChartData(response.getDebtsByMonth);
        this.props.setReceivableCustomersChartData(response.getReceivableByCustomer);
        this.props.setSupplierDebtsChartData(response.getSupplierDebtsAndCollections);
        this.setState({ isLoad: false });
      });

    }
    catch (e) {
      this.setState({ isLoad: false });
      console.log(e);
    }
  }

  handleChange = (e) => {
    const { id, value } = e.target;
    const formData = { ...this.state.formData };
    formData[id] = value;
    this.setState({ formData });
  };
  handleCustomerChange = (selectedOption) => {
    if (!selectedOption) {
      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          by_customer: ''
        },
        selectedCustomer: null
      }));
      return;
    }

    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        by_customer: selectedOption.value,
        by_supplier: '' // Müşteri seçilince tedarikçiyi temizle
      },
      selectedCustomer: selectedOption,
      selectedSupplier: null
    }));
  };

  handleSupplierChange = (selectedOption) => {
    if (!selectedOption) {
      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          by_supplier: ''
        },
        selectedSupplier: null
      }));
      return;
    }

    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        by_supplier: selectedOption.value,
        by_customer: '' // Tedarikçi seçilince müşteriyi temizle
      },
      selectedSupplier: selectedOption,
      selectedCustomer: null
    }));
  };

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  };

  toggleOverpaidModal = () => {
    this.setState({ overpaidModalOpen: !this.state.overpaidModalOpen });
  };

  fetchOverpaidSuppliers = async () => {
    this.setState({ loadingOverpaid: true, overpaidModalOpen: true });

    try {
      const { formData } = this.state;
      const params = new URLSearchParams();

      if (formData.startDateTime) params.append('start_date', formData.startDateTime);
      if (formData.endDateTime) params.append('end_date', formData.endDateTime);

      const url = `business/reports/overpaid-suppliers?${params.toString()}`;
      console.log('📡 Fazla ödeme API çağrısı yapılıyor:', url);

      const response = await apiCall(url, 'get');

      console.log('📥 Backend yanıtı:', response);

      if (response && response.success) {
        console.log('✅ Fazla ödeme verileri:', response.data);
        this.setState({
          overpaidSuppliers: response.data || [],
          loadingOverpaid: false
        });
      } else {
        console.warn('⚠️ Backend success=false döndü veya response yok');
        this.setState({
          overpaidSuppliers: [],
          loadingOverpaid: false
        });
      }
    } catch (error) {
      console.error('❌ Fazla ödeme verileri alınamadı:', error);
      this.setState({
        overpaidSuppliers: [],
        loadingOverpaid: false
      });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ loading: true });
    const { formData } = this.state;
    const reportFormData = new FormData();
    Object.keys(formData).forEach(key => {
      reportFormData.append(key, formData[key]);
    });
    try {
      const response = await apiCall('business/reports/receivable', 'post', reportFormData);

      // DEBUG: Filtrelenmiş verileri konsola yazdır
      console.log('📊 CARİ RAPOR - FİLTRELENMİŞ VERİLER:', {
        'Filtreler': {
          'Başlangıç': formData.startDateTime || 'YOK',
          'Bitiş': formData.endDateTime || 'YOK',
          'Müşteri': formData.by_customer || 'YOK',
          'Tedarikçi': formData.by_supplier || 'YOK',
          'Şube': formData.by_branch || 'YOK',
        },
        'Toplam Alacak': response.total?.totalReceivables,
        'Toplam Tahsilat': response.total?.totalCollectedReceivables,
        'Kalan Alacak': response.total?.totalRemainingReceivables,
        'Toplam Borç': response.total?.totalDebts,
        'Toplam Ödeme': response.total?.totalCollectedDebts,
        'Kalan Borç': response.total?.totalRemainingDebts,
      });

      this.setState({
        receivablesTotals: response.receivableTotals,
        receivablesChartData: response.getReceivableByMonth,
        debtsDataChart: response.getDebtsByMonth,
        receivablesCustomersChartData: response.getReceivableByCustomer,
        supplierDebtsChartData: response.getSupplierDebtsAndCollections,
        total: response.total,
      }, () => {
        this.props.setReceivableChartData(response.getReceivableByMonth);
        this.props.setDebtsChartData(response.getDebtsByMonth);
        this.props.setReceivableCustomersChartData(response.getReceivableByCustomer);
        this.props.setSupplierDebtsChartData(response.getSupplierDebtsAndCollections);
        this.setState({ isLoad: false });
      });
      this.setState({ loading: false });
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      this.setState({ loading: false });
    }

  }
  render() {
    const {
      loading,
      isLoad,
      branches,
      customers,
      receivablesChartData,
      debtsDataChart,
      receivablesCustomersChartData,
      supplierDebtsChartData,
      total,
      selectedCustomer,
      selectedSupplier
    } = this.state;
    const customerFormattedOptions = customers
      .filter(option => option.is_supplier === 0)
      .map(option => ({
        value: option.id,
        label: option.name + ' ' + (option.surname || "")
      }));
    const supplierFormattedOptions = customers
      .filter(option => option.is_supplier === 1)
      .map(option => ({
        value: option.id,
        label: option.name + ' ' + (option.surname || "")
      }));
    // Alacak ve borç değerlerini güvenli şekilde parse et
    let remainingRec = parseFloat(total.totalRemainingReceivables) || 0;
    let remainingDebt = parseFloat(total.totalRemainingDebts) || 0;

    // Fazla ödeme kontrolü (negatif değer = fazla ödeme yapılmış)
    const hasOverpaymentToSuppliers = remainingDebt < 0;
    const overpaymentAmount = hasOverpaymentToSuppliers ? Math.abs(remainingDebt) : 0;

    // Negatif alacak kontrolü (olmaması gereken durum)
    if (remainingRec < 0) {
      console.warn('⚠️ Negatif alacak değeri tespit edildi:', remainingRec);
      remainingRec = Math.abs(remainingRec);
    }
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Cari Raporları"
              Breadcrumb={[
                { name: "Raporlar", navigate: "" },
                { name: "Finans", navigate: "" },
                { name: "Cari Raporları", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <form onSubmit={this.handleSubmit}>
                    <div className="body">
                      <div className="row clearfix">
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="startDateTime" className="font-weight-bold text-cyan">
                              Başlangıç Tarihi
                            </label>
                            <input
                              id="startDateTime"
                              className="form-control"
                              type="datetime-local"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="endDateTime" className="font-weight-bold text-cyan">
                              Bitiş Tarihi
                            </label>
                            <input
                              id="endDateTime"
                              className="form-control"
                              type="datetime-local"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="by_customer" className="font-weight-bold text-cyan">
                              Müşteri
                            </label>
                            <div className="form-group">
                              <Select
                                id="customer"
                                placeholder="Müşteri Seçiniz..."
                                options={customerFormattedOptions}
                                value={selectedCustomer}
                                onChange={this.handleCustomerChange}
                                isClearable
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="by_supplier" className="font-weight-bold text-cyan">
                              Tedarikçi
                            </label>
                            <div className="form-group">
                              <Select
                                id="supplier"
                                placeholder="Tedarikçi Seçiniz..."
                                options={supplierFormattedOptions}
                                value={selectedSupplier}
                                onChange={this.handleSupplierChange}
                                isClearable
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="by_branch" className="font-weight-bold text-cyan">
                              Şube
                            </label>
                            <select name="by_branch" id="by_branch" className="form-control"
                              onChange={this.handleChange}>
                              <option value="">Seçiniz</option>
                              {branches && branches.map((branch) => (
                                <option key={branch.id} value={branch.id}>
                                  {branch.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="body">
                      <div className="col-lg-12 d-flex justify-content-center">
                        <div className="col-lg-4">
                          <div className="form-group">
                            {loading ? (
                              <button className="btn btn-outline-primary btn-sm btn-block" disabled={true}
                                style={{ textAlign: "-webkit-center" }}>
                                Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'}
                                  color="#268bd2"></ReactLoading>
                              </button>
                            ) :
                              <button className="btn btn-outline-primary btn-sm btn-block"
                                type="submit">
                                Güncelle
                              </button>}
                          </div>
                        </div>
                      </div>

                    </div>
                  </form>

                  {/* Tab Seçimi */}
                  <div className="body">
                    <div className="row clearfix">
                      <div className="col-12">
                        <ul className="nav nav-tabs" style={{ borderBottom: '2px solid #e9ecef' }}>
                          <li className="nav-item">
                            <button
                              className={`nav-link ${this.state.activeTab === 'receivables' ? 'active' : ''}`}
                              onClick={() => this.handleTabChange('receivables')}
                              style={{
                                border: 'none',
                                background: this.state.activeTab === 'receivables' ? 'linear-gradient(135deg, #28a745 0%, #20c997 100%)' : 'transparent',
                                color: this.state.activeTab === 'receivables' ? 'white' : '#6c757d',
                                fontWeight: '600',
                                padding: '12px 24px',
                                borderRadius: '8px 8px 0 0',
                                marginRight: '4px',
                                cursor: 'pointer',
                                transition: 'all 0.3s'
                              }}
                            >
                              <i className="fa fa-arrow-up mr-2"></i>
                              Müşteri Alacakları
                            </button>
                          </li>
                          <li className="nav-item">
                            <button
                              className={`nav-link ${this.state.activeTab === 'debts' ? 'active' : ''}`}
                              onClick={() => this.handleTabChange('debts')}
                              style={{
                                border: 'none',
                                background: this.state.activeTab === 'debts' ? 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)' : 'transparent',
                                color: this.state.activeTab === 'debts' ? 'white' : '#6c757d',
                                fontWeight: '600',
                                padding: '12px 24px',
                                borderRadius: '8px 8px 0 0',
                                cursor: 'pointer',
                                transition: 'all 0.3s'
                              }}
                            >
                              <i className="fa fa-arrow-down mr-2"></i>
                              Tedarikçi Borçları
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* Müşteri Alacakları Tab */}
                  {this.state.activeTab === 'receivables' && (
                    <div className="body">
                      <div className="row clearfix">
                        <div className="col-lg-6 col-md-12">
                          <div className="card">
                            <div className="body top_counter" style={{
                              background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                              borderTopLeftRadius: '14px',
                              borderTopRightRadius: '14px'
                            }}>
                              <div className="icon bg-transparent">
                                <i className="fa fa-arrow-up text-white"></i>
                              </div>
                              <div className="content text-light">
                                <div>Toplam Alacaklar</div>
                                <h6>Tahsilatlar</h6></div>
                            </div>
                            <div className="list-group list-widget">
                              <Link to="#" className="list-group-item">
                                <span className="badge badge-success" style={{ fontSize: "medium" }}>{total.totalReceivablesCount}</span>
                                <i className="fa fa-plus-circle text-muted"></i>Toplam Alacak Adedi
                              </Link>
                              <Link to="#" className="list-group-item">
                                <span className="badge badge-info" style={{ fontSize: "medium" }}>{formattedPrice(total.totalReceivables)}</span>
                                <i className="fa fa-plus-circle text-muted"></i>Toplam Alacak Tutarı
                              </Link>
                              <Link to="#" className="list-group-item">
                                <span className="badge badge-warning" style={{ fontSize: "medium" }}>{formattedPrice(total.totalCollectedReceivables)}</span>
                                <i className="fa fa-plus-circle text-muted"></i>Toplam Tahsil Edilmiş Tutar
                              </Link>
                              <Link to="#" className="list-group-item">
                                <span className="badge badge-danger" style={{ fontSize: "medium" }}>{formattedPrice(total.totalRemainingReceivables)}</span>
                                <i className="fa fa-plus-circle text-muted"></i> Toplam Kalan Alacak Tutarı
                              </Link>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="card">
                            <div className="body top_counter" style={{
                              background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                              borderTopLeftRadius: '14px',
                              borderTopRightRadius: '14px'
                            }}>
                              <div className="icon bg-transparent">
                                <i className="fa fa-line-chart text-white"></i>
                              </div>
                              <div className="content text-light">
                                <div>Net Durum (Müşteri)</div>
                                <h6>Toplam Kalan Alacak</h6>
                              </div>
                            </div>
                            <div className="list-group list-widget">
                              <Link to="#" className="list-group-item">
                                <span className="badge badge-success" style={{ fontSize: "medium" }}>
                                  {formattedPrice(remainingRec)}
                                </span>
                                <i className="fa fa-plus-circle text-muted"></i>
                                Müşterilerden Kalan Alacak Tutarı
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Tedarikçi Borçları Tab */}
                  {this.state.activeTab === 'debts' && (
                    <div className="body">
                      <div className="row clearfix">
                        <div className="col-lg-6 col-md-12">
                          <div className="card">
                            <div className="body top_counter" style={{
                              background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                              borderTopLeftRadius: '14px',
                              borderTopRightRadius: '14px'
                            }}>
                              <div className="icon bg-transparent">
                                <i className="fa fa-arrow-down text-white"></i>
                              </div>
                              <div className="content text-light">
                                <div>Toplam Borçlar</div>
                                <h6>Ödemeler</h6>
                              </div>
                            </div>
                            <div className="list-group list-widget">
                              <Link to="#" className="list-group-item">
                                <span className="badge badge-success" style={{ fontSize: "medium" }}>{total.totalDebtsCount}</span>
                                <i className="fa fa-minus-circle text-muted"></i>Toplam Borç Adedi
                              </Link>
                              <Link to="#" className="list-group-item">
                                <span className="badge badge-info" style={{ fontSize: "medium" }}>{formattedPrice(total.totalDebts)}</span>
                                <i className="fa fa-minus-circle text-muted"></i> Toplam Borç Tutarı
                              </Link>
                              <Link to="#" className="list-group-item">
                                <span className="badge badge-warning" style={{ fontSize: "medium" }}>{formattedPrice(total.totalCollectedDebts)}</span>
                                <i className="fa fa-minus-circle text-muted"></i> Toplam Ödenmiş Tutar
                              </Link>
                              <Link to="#" className="list-group-item">
                                {hasOverpaymentToSuppliers ? (
                                  <>
                                    <span className="badge badge-info" style={{ fontSize: "medium" }}>
                                      -{formattedPrice(overpaymentAmount)}
                                    </span>
                                    <i className="fa fa-plus-circle text-info"></i> Toplam Kalan Borç Tutarı (Kredi Bakiyesi)
                                  </>
                                ) : (
                                  <>
                                    <span className="badge badge-danger" style={{ fontSize: "medium" }}>{formattedPrice(Math.abs(remainingDebt))}</span>
                                    <i className="fa fa-minus-circle text-muted"></i> Toplam Kalan Borç Tutarı
                                  </>
                                )}
                              </Link>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="card">
                            <div className="body top_counter" style={{
                              background: hasOverpaymentToSuppliers
                                ? 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)'
                                : 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                              borderTopLeftRadius: '14px',
                              borderTopRightRadius: '14px'
                            }}>
                              <div className="icon bg-transparent">
                                <i className={`fa ${hasOverpaymentToSuppliers ? 'fa-check-circle' : 'fa-line-chart'} text-white`}></i>
                              </div>
                              <div className="content text-light">
                                <div>Net Durum (Tedarikçi)</div>
                                <h6>{hasOverpaymentToSuppliers ? 'Fazla Ödeme (Kredi)' : 'Toplam Kalan Borç'}</h6>
                              </div>
                            </div>
                            <div className="list-group list-widget">
                              <Link to="#" className="list-group-item">
                                {hasOverpaymentToSuppliers ? (
                                  <>
                                    <span className="badge badge-info" style={{ fontSize: "medium" }}>
                                      {formattedPrice(overpaymentAmount)}
                                    </span>
                                    <i className="fa fa-check-circle text-info"></i>
                                    Kredi Bakiyesi (Fazla Ödeme Tutarı)
                                  </>
                                ) : (
                                  <>
                                    <span className="badge badge-danger" style={{ fontSize: "medium" }}>
                                      {formattedPrice(Math.abs(remainingDebt))}
                                    </span>
                                    <i className="fa fa-minus-circle text-muted"></i>
                                    Tedarikçilere Kalan Borç Tutarı
                                  </>
                                )}
                              </Link>
                            </div>
                            {hasOverpaymentToSuppliers && (
                              <div className="card-footer text-center" style={{ background: '#f8f9fa', borderTop: '1px solid #e9ecef' }}>
                                <button
                                  className="btn btn-sm btn-info"
                                  onClick={this.fetchOverpaidSuppliers}
                                  style={{
                                    fontWeight: '600',
                                    padding: '8px 20px',
                                    borderRadius: '6px'
                                  }}
                                >
                                  <i className="fa fa-eye mr-2"></i>
                                  Detayları Gör
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Alacaklar Tab - Grafikler */}
                  {this.state.activeTab === 'receivables' && (
                    <>
                      <div className="body">
                        <div className="row clearfix">
                          <div className="col-lg-12 col-md-12">
                            <div className="card" style={{
                              border: 'none',
                              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                              borderRadius: '12px'
                            }}>
                              <div className="header" style={{ borderBottom: '2px solid #28a745' }}>
                                <h2 style={{ color: '#28a745' }}>
                                  <i className="fa fa-line-chart mr-2"></i>
                                  Alacak Tahsilat Grafiği
                                </h2>
                              </div>
                              {!isLoad ? (
                                receivablesChartData && Object.keys(receivablesChartData).length > 0 ? (
                                  <ReceivableDataChart></ReceivableDataChart>
                                ) : (
                                  <div className="alert alert-warning text-center">Veri yok</div>
                                )
                              ) : ""}
                            </div>
                          </div>
                        </div>
                        <div className="row clearfix">
                          <div className="col-lg-12 col-md-12">
                            <div className="card" style={{
                              border: 'none',
                              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                              borderRadius: '12px'
                            }}>
                              <div className="header" style={{ borderBottom: '2px solid #28a745' }}>
                                <h2 style={{ color: '#28a745' }}>
                                  <i className="fa fa-pie-chart mr-2"></i>
                                  Müşteri Bazlı Alacaklar ve Tahsilatlar
                                </h2>
                              </div>
                              {!isLoad ? (
                                receivablesCustomersChartData && Object.keys(receivablesCustomersChartData).length > 0 ? (
                                  <ReceivableByCustomerPieChart></ReceivableByCustomerPieChart>
                                ) : (
                                  <div className="alert alert-warning text-center">Veri yok</div>
                                )
                              ) : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="body">
                        <div className="row clearfix">
                          <div className="col-lg-12 col-md-12">
                            <div className="card" style={{
                              border: 'none',
                              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                              borderRadius: '12px',
                              borderLeft: '4px solid #28a745'
                            }}>
                              <div className="header" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
                                <h2 style={{ color: '#28a745' }}>
                                  <i className="fa fa-clock-o mr-2"></i>
                                  Yaklaşan Alacaklar
                                </h2>
                              </div>
                              <ApproachingReceivablesTable></ApproachingReceivablesTable>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* Borçlar Tab - Grafikler */}
                  {this.state.activeTab === 'debts' && (
                    <>
                      <div className="body">
                        <div className="row clearfix">
                          <div className="col-lg-12 col-md-12">
                            <div className="card" style={{
                              border: 'none',
                              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                              borderRadius: '12px'
                            }}>
                              <div className="header" style={{ borderBottom: '2px solid #dc3545' }}>
                                <h2 style={{ color: '#dc3545' }}>
                                  <i className="fa fa-line-chart mr-2"></i>
                                  Borç ve Ödeme Grafiği
                                </h2>
                              </div>
                              {!isLoad ? (
                                debtsDataChart && Object.keys(debtsDataChart).length > 0 ? (
                                  <DebtsDataChart></DebtsDataChart>
                                ) : (
                                  <div className="alert alert-warning text-center">Veri yok</div>
                                )
                              ) : ""}
                            </div>
                          </div>
                        </div>
                        <div className="row clearfix">
                          <div className="col-lg-12 col-md-12">
                            <div className="card" style={{
                              border: 'none',
                              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                              borderRadius: '12px'
                            }}>
                              <div className="header" style={{ borderBottom: '2px solid #dc3545' }}>
                                <h2 style={{ color: '#dc3545' }}>
                                  <i className="fa fa-pie-chart mr-2"></i>
                                  Tedarikçi Bazlı Borçlar ve Ödemeler
                                </h2>
                              </div>
                              {!isLoad ? (
                                supplierDebtsChartData && Object.keys(supplierDebtsChartData).length > 0 ? (
                                  <DebtsBySupplierPieChart></DebtsBySupplierPieChart>
                                ) : (
                                  <div className="alert alert-warning text-center">Veri yok</div>
                                )
                              ) : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="body">
                        <div className="row clearfix">
                          <div className="col-lg-12 col-md-12">
                            <div className="card" style={{
                              border: 'none',
                              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                              borderRadius: '12px',
                              borderLeft: '4px solid #dc3545'
                            }}>
                              <div className="header" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
                                <h2 style={{ color: '#dc3545' }}>
                                  <i className="fa fa-clock-o mr-2"></i>
                                  Yaklaşan Borçlar
                                </h2>
                              </div>
                              <ApproachingDebtsTable></ApproachingDebtsTable>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Fazla Ödeme Detay Modal */}
        <Modal
          isOpen={this.state.overpaidModalOpen}
          toggle={this.toggleOverpaidModal}
          size="lg"
          style={{ maxWidth: '900px' }}
        >
          <ModalHeader toggle={this.toggleOverpaidModal}>
            <i className="fa fa-info-circle text-info mr-2"></i>
            Fazla Ödeme Yapılan Tedarikçiler
          </ModalHeader>
          <ModalBody>
            <div className="alert alert-warning" style={{ borderLeft: '4px solid #ffc107' }}>
              <i className="fa fa-lightbulb-o mr-2"></i>
              <strong>Not:</strong> Bu liste <strong>sadece fazla ödeme yapılan</strong> tedarikçileri gösterir.
              Borcu olan tedarikçiler bu listede yer almaz. Net Durum kartındaki tutar,
              tüm tedarikçilerin net durumunu (fazla ödemeler - borçlar) gösterir.
            </div>
            {this.state.loadingOverpaid ? (
              <div className="text-center py-5">
                <ReactLoading type="spin" color="#17a2b8" height={50} width={50} className="mx-auto" />
                <p className="mt-3 text-muted">Veriler yükleniyor...</p>
              </div>
            ) : this.state.overpaidSuppliers.length === 0 ? (
              <div className="alert alert-info text-center">
                <i className="fa fa-info-circle mr-2"></i>
                Seçilen tarih aralığında fazla ödeme yapılan tedarikçi bulunmamaktadır.
              </div>
            ) : (
              <div className="table-responsive">
                <Table striped bordered hover>
                  <thead style={{ background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)', color: 'white' }}>
                    <tr>
                      <th>#</th>
                      <th>Tedarikçi Adı</th>
                      <th>İletişim</th>
                      <th className="text-right">Toplam Borç</th>
                      <th className="text-right">Toplam Ödeme</th>
                      <th className="text-right">Fazla Ödeme</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.overpaidSuppliers.map((supplier, index) => (
                      <tr key={supplier.supplier_id}>
                        <td>{index + 1}</td>
                        <td>
                          <strong>{supplier.supplier_name}</strong>
                        </td>
                        <td>
                          <div style={{ fontSize: '0.85rem' }}>
                            {supplier.supplier_email && (
                              <div><i className="fa fa-envelope text-muted mr-1"></i> {supplier.supplier_email}</div>
                            )}
                            {supplier.supplier_phone && (
                              <div><i className="fa fa-phone text-muted mr-1"></i> {supplier.supplier_phone}</div>
                            )}
                          </div>
                        </td>
                        <td className="text-right">
                          <span className="badge badge-warning" style={{ fontSize: '0.9rem' }}>
                            {formattedPrice(supplier.total_debt)}
                          </span>
                        </td>
                        <td className="text-right">
                          <span className="badge badge-success" style={{ fontSize: '0.9rem' }}>
                            {formattedPrice(supplier.total_payment)}
                          </span>
                        </td>
                        <td className="text-right">
                          <span className="badge badge-info" style={{ fontSize: '1rem', fontWeight: '600' }}>
                            {formattedPrice(supplier.overpayment_amount)}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot style={{ background: '#f8f9fa', fontWeight: '600' }}>
                    <tr>
                      <td colSpan="5" className="text-right">
                        <strong>TOPLAM FAZLA ÖDEME:</strong>
                        <br />
                        <small className="text-muted" style={{ fontWeight: 'normal' }}>
                          (Borcu olan tedarikçiler hariç)
                        </small>
                      </td>
                      <td className="text-right">
                        <span className="badge badge-info" style={{ fontSize: '1.1rem', fontWeight: '700' }}>
                          {formattedPrice(
                            this.state.overpaidSuppliers.reduce((sum, s) => sum + parseFloat(s.overpayment_amount), 0)
                          )}
                        </span>
                      </td>
                    </tr>
                  </tfoot>
                </Table>
              </div>
            )}
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = ({ analyticalReducer }) => ({
  receivablesChartData: analyticalReducer.receivablesChartData,
  receivablesCustomersChartData: analyticalReducer.receivablesCustomersChartData,
  debtsDataChart: analyticalReducer.debtsDataChart,
  supplierDebtsChartData: analyticalReducer.supplierDebtsChartData,
});

export default withPermissions(withRouter(connect(mapStateToProps, {
  setReceivableChartData, setReceivableCustomersChartData, setDebtsChartData, setSupplierDebtsChartData
})(ReceivableReports)));
